export const TESTING_REPORTS = 1;
export const CONSULTANCY = 2;
export const PROJECT_MANAGEMENT = 3;
export const MJ_REQUESTS = 4;



export const PROJECT_TYPE_TITLES = {
    [TESTING_REPORTS]: 'Testing Reports',
    [CONSULTANCY]: 'Consultancy',
    [PROJECT_MANAGEMENT]: 'Project Management',
    [MJ_REQUESTS]: 'M & J Requests'
};